import { motion } from "framer-motion";
import { waLink, SITE } from "@/lib/siteConfig";

const STEPS = [
  {
    n: "01",
    title: "Kirim Detail Device",
    desc: "Kirim foto, tipe, dan kondisi device kamu lewat Whatsapp untuk proses pengecekan awal",
  },
  {
    n: "02",
    title: "Estimasi Harga",
    desc: "Tim kami akan bantu cek kondisi device kamu dan memberikan estimasi harga terbaik.",
  },
  {
    n: "03",
    title: "Deal & Transaksi",
    desc: "Setelah pengecekan, kamu bisa melanjutkan transaksi dengan walk-in atau COD",
  },
];

const PRODUCTS = [
  {
    image: "/brand/1.png",
    name: "ipad 7 32gb gray - ex inter",
    price: "Rp1.800.000",
    desc: "Fullset original",
    battery: "normal",
    condition: "Minus layar black spot, tidak menengganggu fungsional",
  },
  {
    image: "/brand/2.png",
    name: "MacBook Pro M1 Space Grey - Ex Inter",
    price: "Rp9.000.000",
    desc: "Unit + Original Magsafe & Cable.",
    battery: "Battery Cycle Count 365, Battery Health 85%",
    condition: "No Minus",
  },
  {
    image: "/brand/3.png",
    name: 'iPhone XR 64 GB White - Ex Digimap',
    price: "Rp3.300.000",
    desc: "Fullset Original",
    battery: "75%",
    condition: "No Minus",
  },
  {
    image: "/brand/4.png",
    name: 'iPad Pro M2 11inch Space Grey - ex Inter',
    price: "Rp9.750.000",
    desc: "Fullset Original",
    battery: "95%",
    condition: "No Minus",
  },
  {
    image: "/brand/5.png",
    name: "iPhone 15 256 Black - Ex iBox",
    price: "Rp11.800.000",
    desc: "Fullset Original",
    battery: "85%",
    condition: "No Minus",
  },
  {
    image: "/brand/6.png",
    name: "iPhone 16 plus 128 Teal - Ex iBox",
    price: "Rp13.250.000",
    desc: "Fullset Original",
    battery: "95%",
    condition: "No Minus",
  },
];

export default function BuySellSection() {
  return (
    <section
      id="jualbeli"
      className="py-20 lg:py-28 bg-white"
      data-testid="jualbeli-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">

          {/* LEFT SIDE */}
          <div className="lg:col-span-5">
            <div className="eyebrow mb-4">Jual & Beli</div>

            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
              Mau jual, beli, atau tukar tambah?
              <br />
              <span className="text-[#FF6B00]">
                Semua bisa di sini.
              </span>
            </h2>

            <p className="mt-6 text-[#525252] text-lg leading-relaxed">
              Tersedia iPhone, MacBook, iPad, Apple Watch, dan Android baru
              maupun second dengan pilihan garansi resmi Indonesia dan inter.
              Bisa jual, beli, hingga tukar tambah dalam satu tempat.
            </p>

            {/* YELLOW BOX */}
            <div className="mt-8 border border-[#0A0A0A] bg-[#FFD600] p-6">
              <p className="font-display text-2xl font-bold leading-tight">
                Dapatkan penawaran hingga{" "}
                <span className="text-[#FF3333]">90%</span> dari harga pasar!*
                <br />

                <span className="text-sm opacity-60 font-medium">
                  *Syarat dan ketentuan berlaku
                </span>
              </p>

              <a
                href={waLink(SITE.waMessages.tradeIn)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-ez btn-ez-dark mt-5"
                data-testid="trade-in-cta"
              >
                Hubungi via Whatsapp
              </a>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="lg:col-span-7">

            {/* IMAGE */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
              className="relative aspect-[16/10] overflow-hidden border border-[#0A0A0A]"
            >
              <img
                src="/brand/photo-store-ai.png"
                alt="Jual Beli Tukar Tambah MacBook iPad iPhone"
                className="w-full h-full object-cover"
                data-testid="buysell-image"
              />
            </motion.div>

            {/* MESSAGE */}
            <div className="mt-8 mb-5 border border-[#E5E5E5] bg-[#F8F8F8] p-4">
              <p className="text-sm text-[#525252] leading-relaxed">
                <span className="font-semibold text-[#0A0A0A]">
                  Cukup 3 langkah buat jual atau tukar tambah device kamu:
                </span>
              </p>
            </div>

            {/* STEP BOXES */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {STEPS.map((s, i) => (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="p-5 border border-[#E5E5E5] hover:border-[#FF3333] transition-colors"
                  data-testid={`buysell-step-${i + 1}`}
                >
                  <div className="font-mono-ez text-xs text-[#FF3333] font-bold tracking-widest">
                    {s.n}
                  </div>

                  <h4 className="font-display text-lg font-bold mt-3">
                    {s.title}
                  </h4>

                  <p className="text-sm text-[#525252] mt-1.5">
                    {s.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* READY UNIT TITLE */}
        <div className="mt-14 mb-6 text-center">
          <h3 className="font-display text-3xl lg:text-4xl font-black tracking-tight">
            Ready Unit <span className="text-[#FF6B00]">Second</span>
          </h3>
        </div>

        {/* PRODUCT GRID */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {PRODUCTS.map((product, i) => (
            <motion.div
              key={product.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="border border-[#0A0A0A] bg-[#0A0A0A] text-white overflow-hidden"
            >
              {/* IMAGE */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* CONTENT */}
              <div className="p-5">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-display text-2xl font-bold">
                    {product.name}
                  </h4>

                  <span className="text-[#FFD600] text-sm font-semibold">
                    Ready
                  </span>
                </div>

                <p className="text-[#FFD600] font-bold text-lg mb-3">
                  {product.price}
                </p>

                <p className="text-sm text-white/70 leading-relaxed mb-5">
                  {product.desc}
                </p>

                {/* SPECS */}
                <div className="space-y-2">
                  <div className="border border-white/10 px-3 py-2 text-sm">
                    🔋 {product.battery}
                  </div>

                  <div className="border border-white/10 px-3 py-2 text-sm">
                    ✨ {product.condition}
                  </div>
                </div>

                {/* BUTTON */}
                <a
                  href="https://linktr.ee/ezdevice"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 inline-flex w-full items-center justify-center border border-[#FFD600] text-[#FFD600] py-3 text-sm font-semibold hover:bg-[#FFD600] hover:text-black transition-colors"
                >
                  Tanya Unit
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}